export const GeolocationQcFieldName = 'geolocationQcFieldComponent';
